import React, { useState, useRef, useContext } from 'react';
import '../../../globalstyle/vars.css';
import { InitialValuesType, InputsEntity, SendAsyncPostObject } from '../../types';
import { postContactFormDataService } from '../../services/sitecoreServices';
import { Skeleton } from '../../components/Skeleton';
import { gtagEnvelope } from '../../util/gtagEnvelope';
import { ContactSalesView } from './ContactSalesView';
import { ContentContext } from '../../context/ContentContext';
import { Error } from '../Error/Error';
import { getCookie, setCookie } from '../../util/cookies';
import { FormikProps } from 'formik';
import { analyticsEvent } from '~/common/util/analyticsEvent';

export function ContactSales() {
  const formikRef = useRef<FormikProps<SendAsyncPostObject>>(null);
  const [optOutOfEmails, setOptOutOfEmails] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [displayUnsubscribeCheckbox, setDisplayUnsubscribeCheckbox] = useState(false);
  const [isBannerClosed, setIsBannerClosed] = useState(false);
  const parsedPageTitle = document.title.replace(/\s/g, '');
  const pageId = parsedPageTitle.length > 0 ? parsedPageTitle : '';
  const initialValues: InitialValuesType = {};
  const data = useContext(ContentContext);
  const countryCookie: string | null = getCookie('cciso');
  const [textareaExists, setTextareaExists] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);

  const toggleModalState = (boolean: boolean) => {
    setIsModalOpen(boolean);
  };

  const setClosedBanner = (value: boolean) => {
    if (value !== isBannerClosed) {
      setIsBannerClosed(value);
    }
  };

  const handleSub = async (values: SendAsyncPostObject) => {
    setFormSubmitting(true);
    setClosedBanner(false);
    const success = await postContactFormDataService(values, optOutOfEmails, textareaExists);
    if (!success) {
      setIsModalOpen(true);
      trackError();
      setFormSubmitting(false);
      return false;
    } else {
      await analyticsEvent(values.email.toString());
      if (typeof values.campaignType === 'string' && values.campaignType === 'gated-content') {
        setCookie('lp_gatedcontent', 'true');
      }
      window.location.href = data!.successUrl;
    }
    return true;
  };
  const unsubscribeClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'SPAN') {
      setDisplayUnsubscribeCheckbox(!displayUnsubscribeCheckbox);
    }
  };
  const trackError = () => {
    gtagEnvelope('event', 'form_error', {
      form_url: window.location.pathname,
      error_message: `processing-error_${pageId}`,
    });
  };

  if (data && data.error !== false) {
    data!.inputs!.forEach((input: InputsEntity) => {
      if (input.id === '') return;
      if (input.id === 'country') {
        initialValues[input.id] = countryCookie ? countryCookie : 'US';
      } else {
        initialValues[input.id] = input.defaultValue;
      }
    });
  }

  if (data === null) return <Skeleton />;
  if (!data || typeof data !== 'object')
    return (
      <Error>
        <h2>Oops!</h2>
        <p>Something went wrong. Please reload or try again later.</p>
      </Error>
    );

  return (
    <ContactSalesView
      toggleModalState={toggleModalState}
      isModalOpen={isModalOpen}
      formikRef={formikRef}
      initialValues={initialValues}
      handleSub={handleSub}
      unsubscribeClick={unsubscribeClick}
      displayUnsubscribeCheckbox={displayUnsubscribeCheckbox}
      optOutOfEmails={optOutOfEmails}
      setOptOutOfEmails={setOptOutOfEmails}
      setClosedBanner={setClosedBanner}
      closedBanner={isBannerClosed}
      setTextareaExistsSetState={() => {
        setTextareaExists(true);
      }}
      formSubmitting={formSubmitting}
    />
  );
}
